module.exports = __webpack_public_path__ + "img/us-6.b22ca620.png";